import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {AgendaGenericEventDetailsDialogFooter} from '@/features/agenda/components/agenda-event-details-dialog/AgendaGenericEventDetailsDialogFooter'
import {AgendaGenericEventDetailsDialogBody} from '@/features/agenda/components/agenda-event-details-dialog/AgendaGenericEventDetailsDialogBody'
import {AgendaGenericEventDetailsDialogHeader} from '@/features/agenda/components/agenda-event-details-dialog/AgendaGenericEventDetailsDialogHeader'
import {AgendaEventGeneric} from '@/features/agenda/types'

interface AgendaEventDetailsGenericDialogContentProps {
    agendaEvent: AgendaEventGeneric
}

export const AgendaEventDetailsGenericDialogContent = ({agendaEvent}: AgendaEventDetailsGenericDialogContentProps) => {
    return (
        <>
            <AgendaGenericEventDetailsDialogHeader />
            <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />}>
                <AgendaGenericEventDetailsDialogBody event={agendaEvent} />
            </ScrollArea>
            <AgendaGenericEventDetailsDialogFooter agendaEvent={agendaEvent} />
        </>
    )
}
